import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-orders-reports-amount-sales-card',
  templateUrl: './orders-reports-amount-sales-card.component.html',
  styleUrls: ['./orders-reports-amount-sales-card.component.scss']
})
export class OrdersReportsAmountSalesCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
